import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'

import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export const useGetCampaignAssistantsVoices = (
   queryParams: PaginationQueryParams
) => {
   const response = useSWR(
      [QUERY_KEYS.CAMPAIGN_ACTIVATION_VOICES, { ...queryParams }],
      () => CampaignService.getCampaignAssistantsVoice(queryParams)
   )
   return {
      ...response,
   }
}
